<template>
  <TimeLine ref="Timeline" :timeSegments="subData"></TimeLine>
</template>

<script>
/**
 * 1、能控制推演的起点和终点
 * 2、可以调整动作的演播顺序
 */
import dayjs from "dayjs";

export default {
  props: ["subData"],
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
